export default __webpack_public_path__ + "static/char-sp01-anr-3401e39068756688f74fe78e4626989b.webp";